import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import styles from './FeedbackLevelCard.module.scss';

const STARS_TOTAL = 5;

interface FeedbackLevelCardProps {
  levelLabel: string;
  stars: number;
  supportPhrase: string | null;
}

function FeedbackLevelCard({
  levelLabel,
  stars,
  supportPhrase,
}: FeedbackLevelCardProps): JSX.Element {
  const filledStars = Math.max(0, Math.min(stars, STARS_TOTAL));

  return (
    <div className={styles.container}>
      <p className={styles.eyebrow}>Como está a sua escrita agora</p>

      <h2 className={styles.levelLabel}>
        <span className={styles.starEmoji} aria-hidden="true">
          ⭐
        </span>
        {levelLabel}
      </h2>

      {/* `role="img"` makes `aria-label` become the whole group's accessible name and hides the
      individual icons from screen readers — a generic `div` (implicit role "generic") doesn't
      guarantee `aria-label` is exposed (found by Copilot on the PR, 2026-09-22). */}
      <div
        className={styles.stars}
        role="img"
        aria-label={`${filledStars} de ${STARS_TOTAL} estrelas`}
      >
        {Array.from({length: STARS_TOTAL}).map((_, index) => {
          const isFilled = index < filledStars;

          return (
            <FontAwesomeIcon
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              icon={[isFilled ? 'fas' : 'far', 'star']}
              className={isFilled ? styles.starFilled : styles.starEmpty}
            />
          );
        })}
      </div>

      {supportPhrase && <p className={styles.supportPhrase}>{supportPhrase}</p>}
    </div>
  );
}

export default FeedbackLevelCard;
